import styled from 'styled-components';
import TinyColor from 'tinycolor2';
import Imgix from 'shared/components/imgix';
import { Button } from 'components/core';

export const Row = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[95]};
  }
`;

export const TopLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OrderInfo = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[40]};
  line-height: 1.4;
`;

export const TotalCost = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey[30]};
`;

export const BottomLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Thumbnails = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Thumbnail = styled(Imgix)`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const MoreBadge = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[95]};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.grey[40]};
  display: flex;
  flex-direction: column;
  font-size: 11px;
  height: 48px;
  justify-content: center;
  line-height: 1;
  text-align: center;
  width: 48px;
`;

export const ReorderButton = styled(Button)`
  /* Match ProductCard tinted button styles from card-view.tsx */
  /* Hex alpha 10% */
  background: ${({ theme }) => theme.customized.colors.buttonsLinks}1a;
  color: ${({ theme }) => TinyColor.mix(theme.customized.colors.buttonsLinks, '#000', 20).toString()};
  border: none;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 20px;
  text-transform: uppercase;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.customized.colors.buttonsLinks};
    color: ${({ theme }) => theme.colors.white};
  }
`;
